import React from 'react';
import {
  Filter,
  NumberField,
  FunctionField,
  TextInput,
  NullableBooleanInput,
  List,
  Datagrid,
  TextField,
  LongTextInput,
  DateField,
  ReferenceInput,
  ShowButton,
  SelectInput,
  BooleanField,
  Edit,
  SimpleForm,
  ArrayInput,
  SimpleFormIterator,
  DisabledInput,
  NumberInput,
  CardActions,
  ListButton,
} from 'react-admin';
import Button from '@material-ui/core/Button';

import { appOptions } from '../config/app';

function getParsedDate(date) {
  var dt = new Date(date);
  var year = dt.getFullYear();
  var month = ('00' + (dt.getMonth() + 1)).slice(-2);
  var day = ('00' + dt.getDate()).slice(-2);
  var hour = ('00' + dt.getHours()).slice(-2);
  var minute = ('00' + dt.getMinutes()).slice(-2);
  var second = ('00' + dt.getSeconds()).slice(-2);
  return year + '.' + month + '.' + day + ', ' + hour + ':' + minute + ':' + second;
}

function getCurrentSiteBaseUrl(language) {
  switch (language) {
    case 'mk':
      return 'https://grid.mk';
    case 'bg':
      return 'https://topvesti.bg';
    case 'au':
      return 'https://1000.news';
    case 'mk2':
      return 'https://vesti.mk';
    case 'rs':
      return 'https://topvesti.rs';
    default:
      return null;
  }
}

function getSiteLink(cluster_id, language) {
  if (cluster_id) {
    const lang = language || localStorage.getItem(appOptions.languageKey);
    const site = getCurrentSiteBaseUrl(lang);
    if (site) {
      return `${site}/c/${cluster_id}/`;
    }
  }
  return '#';
}

const ClustersEditActions = ({ basePath, data, resource }) => (
  <CardActions>
      {data && 
        <Button style={{marginRight: '10px'}} variant="outlined" color="primary" href={getSiteLink(data.id)} target="_blank" rel="noopener noreferrer">
          Link
        </Button>}
      <ListButton basePath={basePath} variant="outlined" style={{marginRight: '10px', padding: '7px 16px'}} />
  </CardActions>
);

const ClustersListFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <LongTextInput label="Url" source="x_urls.url" alwaysOn />
    <NullableBooleanInput label="Archive" source="archive" />
    <ReferenceInput label="Category" source="category.ref" reference="articles/categories">
      <SelectInput source="name" />
    </ReferenceInput>
  </Filter>
);

const Title = ({ record }) => {
  return <span>Cluster {record ? `"${record.title}"` : ''}</span>;
};

export const ClusterList = props => (
  <List title="Clusters" {...props} sort={{ field: 'update_date', order: 'desc' }} filters={<ClustersListFilter />}>
    <Datagrid>
      <FunctionField
        source="title"
        render={(record, source) => {
          if(!record['id']) return '';
          const link = getSiteLink(record['id'], props.language);
          return (
            <h3>
              <a href={link} target="_blank" rel="noopener noreferrer">
                {record[source]}
              </a>
            </h3>
          );
        }}
      />
      <FunctionField
        source="top_article"
        render={(record, source) => {
          return (
            record[source] &&
            <a href={record[source]['url']} target="_blank" rel="noopener noreferrer">
              {record[source]['site']}
            </a>
          );
        }}
      />
      <TextField label="Category" source="category.name" />
      <DateField source="create_date" showTime={true} />
      <DateField source="update_date" showTime={true} />
      <NumberField source="coefficient" options={{ useGrouping: false, minimumFractionDigits: 4 }} />
      <BooleanField source="archive" />
      <ShowButton label="" />
    </Datagrid>
  </List>
);

export const ClusterDetails = props => (
  <Edit style={{ width: '100%' }} title={<Title />} actions={<ClustersEditActions />} {...props}> 
    <SimpleForm>
      <TextField source="id" />
      <TextField source="title" style={{ width: '100%' }} />
      <TextField source="coefficient" />
      <TextField label="Category" source="category.name" />
      <DateField source="create_date" showTime />
      <DateField source="update_date" showTime />
      <ArrayInput source={`urls`} className="inline-form big-1">
        <SimpleFormIterator disableRemove disableAdd>
          <FunctionField
            source="url"
            label="url"
            render={record => (
              record.url &&
              <span>{record.site}:<br/>
                <a href={record.url} target="_blank" rel="noopener noreferrer">
                  {record.title}
                </a>
              </span>
            )}
          />
          <DisabledInput source="publish_date" format={v => getParsedDate(v)} />
          <DisabledInput source="coefficient" label="Coefficient" />
          <NumberInput source="manual_weight" label="Weight" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/clusters.js